import Search from "../../../../src/mdx/api/endpoints/search.mdx";
import * as React from 'react';
export default {
  Search,
  React
};